import InvestorSecondaryMarketContent from './investor-secondary-market-content';

export default InvestorSecondaryMarketContent;
